import {DomainObject, oneOf} from 'shared/store';
import {action, observable} from 'mobx';
import User from 'main/stores/users/User';

class TimeOffRequestAssignment extends DomainObject {
  @observable approvalStage;

  @action merge(other) {
    super.merge(other, {
      assigneeUser: User,
      delegatedByUser: User,
      approvalStage: oneOf(['first', 'second'])
    });
  }

}

export default TimeOffRequestAssignment;
